import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import globalRequest from "../../../../utils/global/globalRequest";
import { useDispatch, useSelector } from "react-redux";
import { changeLoader } from "../../../../redux/reducers/loader";
import { setSnackbar } from "../../../../redux/reducers/snackbar";
import * as APIS from "../../../../utils/helper/Enum";
import { getAuth } from "../../../../redux/reducers/loginData";
import {
  Button,
  Img,
  DatepickerInput,
  Text,
  Radio,
  TimeSlotRadio,
} from "components";
import {
  updateOrderData,
  getOrderData,
} from "../../../../redux/reducers/orderData";
import * as CUSTOM from "../../../../utils/helper/custom";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { currentTrigger } from "redux/reducers/trigger";
import { updateOrderSummary } from "redux/reducers/orderSummary";

const Tab = styled.div`
  /* Add the selected styles when the component is selected */
  ${({ isSelected }) =>
    isSelected &&
    ` 
border-color: #BD0043 !important;
`}
`;
const Panal = styled.div`
  /* Add the selected styles when the component is selected */
  ${({ isSelected }) =>
    isSelected &&
    ` 
display: block !important;
`}
`;

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#ffffff",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 400,
    margin: 0,
    marginLeft: "-20px",
    padding: 0,
    boxShadow: "0 0 25px -5px rgb(0 0 0 / 0.1), 0 0 10px -6px rgb(0 0 0 / 0.1)",
    ".MuiTooltip-arrow": {
      color: "#FFFFFF", // Arrow color
      width: "28px", // Arrow width
      height: "16px", // Arrow height
      top: "-7px", // Position where arrow is pointing
      left: "12px!important", // Position where arrow is pointing
    },
  },
}));

const DeliveryDateTime = ({ orderDetails }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const orderData = useSelector(getOrderData);
  const auth = useSelector(getAuth);
  const loadingValue = useSelector(currentTrigger);
  const [slotData, setSlotData] = useState([]);
  const [cartData, setCartData] = useState([]);
  const [prepTime, setPrepTime] = useState("");
  const [timeslotSelected, setTimeslotSelected] = useState(null);
  const [disableTimeButton, setDisableTimeButton] = useState(true);
  const [fastestTimeSlots, setFastestTimeSlots] = useState({});
  const [activeTab, setActiveTab] = useState(null);
  // const [orderSummary, setOrderSummary] = useState(null);

  const [timeslotData, setTimeslotData] = useState({
    is_show: 0,
    day: "",
    initialDate: "",
    date: "",
    user_id: 0,
    guest_id: "",
  });
  const [showDeliveryType, setShowDeliveryType] = useState({
    fastest: false,
    schedule: false,
    loading: true,
  });
  /**
   * change date time in sloat
   */
  const changeDate = (e, type = "") => {
    let date = CUSTOM.convertDateString(e, "yyyy-MM-dd");
    let day = CUSTOM.getDayOfWeek(date);
    const updateTimeslotData = { ...timeslotData };
    updateTimeslotData.date = date;
    updateTimeslotData.day = day;
    if (type == "defaultDate") {
      updateTimeslotData.initialDate = date;
    }
    setTimeslotData(updateTimeslotData);
  };

  /**
   * handle click on sloat
   */
  const handleTabClick = (index) => {
    if (index == 1 && cartData?.length > 3) {
      dispatch(
        setSnackbar({
          snackbarOpen: true,
          snackbarMessage: t("fastestTimeError"),
          snackbarState: "error",
        })
      );
      return;
    }
    //setActiveTab(index);
    dispatch(
      updateOrderData({
        ...orderData,
        deliveryDateTimeActiveTab: index,
        delivery_type: index == 1 ? "fastest" : "schedule",
      })
    );
    // if (!timeslotData?.date && index != 1) {
    //   let newdate = CUSTOM.changeDateFormat(new Date(), "yyyy-MM-dd");
    //   setTimeslotData({ ...timeslotData, date: newdate });
    //   changeDate(newdate);
    // }
  };

  /**
   * Set time sloat time
   */
  const setSlotTime = (items) => {
    setTimeslotSelected(items);
  };

  /**
   * Continue Time
   */
  const continueTime = () => {
    let delivery_type = activeTab == 1 ? "fastest" : "schedule";
    if (delivery_type == "fastest" && orderData?.totalCartItem == 4) {
      dispatch(
        setSnackbar({
          snackbarOpen: true,
          snackbarMessage: t("fastestTimeError"),
          snackbarState: "error",
        })
      );
      return;
    }
    if (delivery_type == "fastest") {
      dispatch(
        updateOrderData({
          ...orderData,
          timeSloat: { id: 0 },
          pageStep: 4,
          delivery_type: delivery_type,
          sloatApiData: [],
          timeslotUserData: timeslotData,
        })
      );
    } else {
      dispatch(
        updateOrderData({
          ...orderData,
          timeSloat: timeslotSelected,
          pageStep: 4,
          delivery_type: delivery_type,
          delivery_date: timeslotData?.date,
          sloatApiData: slotData,
          timeslotUserData: timeslotData,
        })
      );
    }
  };

  /**
   * Get time sloat details
   */
  const getTimeSlots = async () => {
    try {
      let params = {
        ...timeslotData,
        order_id: orderDetails?.orderData?.id,
        user_id: auth?.id,
      };

      if (orderData?.delivery_mode === "home_office") {
        params.drop_zone_id = 0;
      } else {
        params.drop_zone_id = orderData?.home_office?.id;
      }
      dispatch(changeLoader(true));
      let response = await globalRequest(
        APIS?.CUSTOMCAKE?.GET_SLOT_LIST_BY_DATE,
        "get",
        {},
        { params },
        true
      );
      response = response?.data;
      if (response.status != "SUCCESS") {
        setSlotData([]);
      } else {
        setSlotData(response?.data?.slots);
      }
    } catch (e) {}
    dispatch(changeLoader(false));
  };

  /**
   * get Current Time from server
   */
  const getCurrentTime = async () => {
    let newdate = CUSTOM.convertDateString(new Date(), "yyyy-MM-dd");
    try {
      let response = await globalRequest(
        APIS?.CART?.GET_CURRENT_DATE,
        "get",
        {},
        {}
      );
      response = response?.data;
      if (response.status == "SUCCESS") {
        newdate = CUSTOM.convertDateString(response?.data, "yyyy-MM-dd");
      }
    } catch (e) {
      console.log(e?.message);
    }
    changeDate(newdate, "defaultDate");
  };

  /**
   *  Getting Setting data to enable and disable the delivery type buttons
   */
  const getSettingData = async () => {
    dispatch(changeLoader(true));
    let obj = {
      fastest: false,
      schedule: false,
      deliveryByZone5: false,
      lattitude: orderData?.home_office?.itemDetail?.lattitude,
      longitude: orderData?.home_office?.itemDetail?.longitude,
    };
    try {
      let params = {
        lattitude: orderData?.home_office?.itemDetail?.lattitude,
        longitude: orderData?.home_office?.itemDetail?.longitude,
      };
      let response = await globalRequest(
        APIS?.CART?.GET_SETTING_DATA,
        "get",
        {},
        { params },
        true
      );
      response = response?.data;
      if (response?.status == "SUCCESS") {
        let fastestSetting = response?.data?.fastestDeliverySetting == 1;
        let scheduleSetting = response?.data?.scheduleDeliverySetting == 1;
        obj.fastest = fastestSetting;
        obj.schedule = scheduleSetting;
        if (
          (!fastestSetting && !scheduleSetting) ||
          (activeTab == 1 && !fastestSetting) ||
          (activeTab == 2 && !scheduleSetting)
        ) {
          let data = { ...orderData };
          delete data["deliveryDateTimeActiveTab"];
          delete data["delivery_type"];
          if (!scheduleSetting) {
            delete data["timeSloat"];
            delete data["timeslotUserData"];
            setTimeslotSelected(null);
            setTimeslotData({ ...timeslotData, date: "" });
          }
          dispatch(updateOrderData(data));
        }
      }
    } catch (e) {
      console.log(e?.message);
    }
    setShowDeliveryType({ ...obj, loading: false });
    dispatch(changeLoader(false));
  };

  /**
   * get summary api
   */
  const getOrderSummary = async () => {
    let inputData = {
      user_id: auth?.id,
      coupon_code: orderData?.couponCode,
      deliveryType: orderData?.delivery_mode,
      order_id: orderDetails?.orderData?.id,
      delivery_type: orderData?.delivery_type,
    };
    if (
      orderData?.delivery_mode != "buying_for_love" &&
      orderData?.delivery_mode
    ) {
      if (orderData?.delivery_mode == "home_office") {
        inputData.userAddresslat =
          orderData?.home_office?.itemDetail?.lattitude;
        inputData.userAddresslong =
          orderData?.home_office?.itemDetail?.longitude;
        inputData.drop_zone_id = 0;
      } else {
        inputData.userAddresslat = orderData?.home_office?.latitude;
        inputData.userAddresslong = orderData?.home_office?.longitude;
        inputData.drop_zone_id = orderData?.home_office?.id;
        inputData.branch_id = orderData?.timeSloat?.branchId || 0;
      }
      inputData.delivery_time_slot_id = orderData?.timeSloat?.id || 0;
    }
    dispatch(changeLoader(true));
    try {
      let response = await globalRequest(
        APIS?.CUSTOMCAKE?.GET_ORDER_SUMMARY,
        "get",
        {},
        { params: inputData },
        true
      );
      response = response?.data;
      if (response?.status == "SUCCESS") {
        setFastestTimeSlots(response?.data?.fastestTimeSlotDetails);
        dispatch(updateOrderSummary(response?.data));

        //  setOrderSummary(response?.data);
      }
    } catch (e) {
      dispatch(updateOrderSummary({}));
      // dispatch(
      //   setSnackbar({
      //     snackbarOpen: true,
      //     snackbarMessage: e?.message,
      //     snackbarState: "error",
      //   })
      // );
    }
    dispatch(changeLoader(false));
  };

  useEffect(() => {
    if (orderData?.pageStep == 3 && orderData?.delivery_type == "schedule") {
      getCurrentTime();
    }
  }, [orderData?.delivery_type, orderData?.pageStep]);

  // useEffect(() => {
  //   let newdate = CUSTOM.changeDateFormat(new Date(), "yyyy-MM-dd");
  //   changeDate(newdate);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [orderData?.DeliveryModeActiveTab]);

  /**
   * Get time sloat data
   */
  useEffect(() => {
    if (timeslotData?.date) {
      getTimeSlots();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timeslotData]);

  /**
   * check sloat exist or not
   */
  useEffect(() => {
    setTimeout(() => {
      if (timeslotSelected != null && slotData.length > 0) {
        let exitOrNot = slotData?.find(
          (item) => item?.id == timeslotSelected?.id
        );
        if (!exitOrNot) {
          dispatch(
            updateOrderData({ ...orderData, timeSloat: { id: 0 }, pageStep: 3 })
          );
          setTimeslotSelected(null);
        }
      }
    }, 1200);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slotData, timeslotSelected]);

  useEffect(() => {
    if (orderDetails) {
      setPrepTime(orderDetails?.orderData?.totalPrepTime);
    }
  }, [orderDetails]);

  useEffect(() => {
    if (orderData?.pageStep == 3 && orderData?.delivery_type) {
      getOrderSummary();
    }
  }, [orderData?.delivery_type]);

  useEffect(() => {
    let a = ["loggedin"];
    if (a.includes(loadingValue)) {
      getTimeSlots();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadingValue]);

  useEffect(() => {
    if (orderData?.pageStep == 3) {
      if (orderData?.delivery_mode == "home_office") {
        setTimeslotData({
          ...timeslotData,
          lat: orderData?.home_office?.itemDetail?.lattitude,
          long: orderData?.home_office?.itemDetail?.longitude,
        });
      } else {
        setTimeslotData({
          ...timeslotData,
          lat: orderData?.home_office?.latitude,
          long: orderData?.home_office?.longitude,
        });
      }
    }
    getOrderSummary();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderData?.pageStep]);

  useEffect(() => {
    if (orderData?.delivery_mode) {
      if (orderData?.delivery_mode) {
        setTimeslotSelected(null);
        dispatch(updateOrderData({ ...orderData, timeSloat: null }));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderData?.delivery_mode]);

  /**
   * check disable button when time change
   */
  useEffect(() => {
    if (activeTab == 2) {
      let status = true;
      let exitOrNot = slotData?.find(
        (item) => item?.id == timeslotSelected?.id
      );
      if (exitOrNot) {
        status = false;
      }
      setDisableTimeButton(status);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slotData, timeslotSelected, orderData?.delivery_type]);

  useEffect(() => {
    setActiveTab(orderData?.deliveryDateTimeActiveTab);
    if (orderData?.deliveryDateTimeActiveTab == 1) {
      setTimeslotData({ ...timeslotData, date: "" });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderData?.deliveryDateTimeActiveTab]);

  useEffect(() => {
    if (orderData?.timeslotUserData) {
      setTimeslotSelected(
        orderData?.timeSloat && orderData?.timeSloat?.id != 0
          ? orderData?.timeSloat
          : null
      );
      setTimeslotData(orderData?.timeslotUserData);
      setSlotData(orderData?.sloatApiData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderData?.timeslotUserData]);

  useEffect(() => {
    setCartData(CUSTOM.getCartData());
  }, [loadingValue]);

  useEffect(() => {
    if (orderData?.pageStep == 3 && orderData?.delivery_mode == "home_office") {
      getSettingData();
      getOrderSummary();
    }
    if (orderData?.pageStep < 3 || orderData?.delivery_mode != "home_office") {
      setShowDeliveryType({
        fastest: false,
        schedule: false,
        loading: true,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderData?.delivery_mode, orderData?.pageStep]);

  return (
    <>
      <div className="relative flex flex-col w-full">
        <div className="flex xs:flex-col xs:items-start flex-row gap-4 items-center justify-between w-full mt-0.5 mb-2">
          <div className="flex flex-col gap-3 flex-row items-start justify-start w-full">
            {orderData?.pageStep < 3 || !orderData?.pageStep ? (
              <div className="flex flex-col gap-1 items-start justify-start flex-1">
                <Text className="text-base text-black-900 font-nunitomedium">
                  {t("deliveryDateAndTime")}
                </Text>
                <div className="flex gap-1 flex-row items-center">
                  <Text className="text-black-900 text-sm font-nunitoregular">
                    {t("forYourItemsChooseTheDeliveryDateAndTime")}
                  </Text>
                </div>
              </div>
            ) : null}

            {orderData?.delivery_mode && orderData?.pageStep > 3 ? (
              <>
                <div className="flex flex-col gap-1 items-start justify-start flex-1">
                  <Text className="text-base text-black-900 font-nunitomedium">
                    {orderData?.delivery_mode == "home_office"
                      ? t("deliveryDateAndTime")
                      : ""}
                    {orderData?.delivery_mode == "pickup_point"
                      ? t("pickUpDateTime")
                      : ""}
                  </Text>
                  <div className="flex gap-1 flex-row items-center">
                    <Text className="text-black-900 text-sm font-nunitoregular">
                      {orderData?.delivery_type != "fastest" ? (
                        <>
                          {CUSTOM.changeDateFormat(
                            timeslotData?.date,
                            "dd/MM/yyyy"
                          )}{" "}
                          {CUSTOM.formatTimeRange(
                            timeslotSelected?.openTime,
                            timeslotSelected?.closeTime
                          )}
                        </>
                      ) : (
                        <></>
                      )}
                      {orderData?.delivery_type == "fastest" ? (
                        <>{t("fastestTime")}</>
                      ) : null}
                    </Text>
                  </div>
                </div>
                <Button
                  className="flex items-center bg-red-50_01 justify-center  px-2 py-[7px] rounded"
                  leftIcon={
                    <Img
                      className="h-[18px] mr-2 rtl:mr-0 rtl:ml-2"
                      src="/images/img_clock.svg"
                      alt="clock"
                    />
                  }
                >
                  <div className="text-left text-gray-900_01 font-nunitomedium text-sm rtl:text-right">
                    {t("estimatedPrepTime")} {CUSTOM.minutsToHour(prepTime)} hrs
                  </div>
                </Button>
              </>
            ) : null}
          </div>
          {orderData?.pageStep > 3 ? (
            <Button
              className="w-auto mx-auto px-3 py-1.5 text-sm xs:mx-0"
              size="sm"
              variant="OutlineBlack"
              hover={true}
              hoverclass="bg-black-900"
              onClick={(e) => {
                dispatch(
                  updateOrderData({
                    ...orderData,
                    timeSloat: null,
                    pageStep: 3,
                  })
                );
              }}
            >
              {t("change")}
            </Button>
          ) : null}
        </div>
        {orderData?.pageStep == 3 ? (
          <>
            <div className="flex xs:flex-col xs:items-start flex-col gap-4 items-center justify-start w-full mt-0.5 mb-2">
              <div className="flex flex-row xs:flex-col xs:items-start md:gap-5 items-center justify-start w-full">
                <div className="flex flex-col gap-1 items-start justify-start flex-1">
                  <Text className="text-base text-black-900 font-nunitomedium">
                    {orderData?.delivery_mode == "home_office"
                      ? t("deliveryDateAndTime")
                      : ""}
                    {orderData?.delivery_mode == "pickup_point"
                      ? t("pickUpDateTime")
                      : ""}
                  </Text>
                  <div className="flex gap-1 flex-row items-center">
                    <Text className="text-black-900 text-sm font-nunitoregular">
                      {t("forYourItemsChooseTheDeliveryDateAndTime")}
                    </Text>
                  </div>
                </div>
                <Button
                  className="flex items-center bg-red-50_01 justify-center  px-2 py-[7px] rounded"
                  leftIcon={
                    <Img
                      className="h-[18px] mr-2 rtl:mr-0 rtl:ml-2"
                      src="/images/img_clock.svg"
                      alt="clock"
                    />
                  }
                >
                  <div className="text-left text-gray-900_01 font-nunitomedium text-sm rtl:text-right">
                    {t("estimatedPrepTime")} {CUSTOM.minutsToHour(prepTime)} hrs
                  </div>
                </Button>
              </div>
            </div>
            <div className="gap-5 grid sm:grid-cols-1 grid-cols-2 justify-center w-full mt-5">
              {showDeliveryType?.loading &&
              orderData?.delivery_mode == "home_office" ? null : (
                <>
                  {orderData?.delivery_mode == "home_office" &&
                  showDeliveryType?.fastest ? (
                    <>
                      <Tab
                        className="common-pointer bg-white-A700 border border-gray-300 border-solid flex flex-1 gap-3 flex-row items-center justify-start p-5 w-full"
                        isSelected={activeTab === 1}
                        onClick={() => handleTabClick(1)}
                        style={cartData.length > 3 ? { opacity: "0.6" } : {}}
                      >
                        <Radio
                          className="flex items-center justify-start"
                          name="Deliverytype"
                          checked={activeTab === 1}
                          onChange={() => handleTabClick(1)}
                        />
                        <div className="flex flex-row gap-1 items-start justify-between w-full">
                          <div className="flex flex-row gap-1 items-start justify-start">
                            <Img
                              className="h-6 w-6"
                              src="/images/img_send.svg"
                              alt="send"
                            />
                            <Text className="text-black-900 text-sm w-auto font-nunitomedium">
                              {t("fastestTime")}
                            </Text>
                          </div>
                          {orderData?.totalCartItem == 4 ? (
                            <HtmlTooltip
                              placement="bottom-start"
                              arrow
                              title={
                                <>
                                  <div className="py-4 px-5 w-full">
                                    <Text className="leading-5 text-black-900 text-sm w-full font-nunitomedium">
                                      {t("fastestTimeError")}
                                    </Text>
                                  </div>
                                </>
                              }
                            >
                              {/* <Radio
                          name="deliveryMode"
                          checked={activeTab === 2}
                          onClick={(e)=>{
                              if(auth?.id!=0){
                                handleTabClick(2)
                              }
                          }}
                        /> */}
                              <div>
                                <Img
                                  className="h-6 w-6"
                                  src="/images/info_icon.svg"
                                  alt="send"
                                />
                              </div>
                            </HtmlTooltip>
                          ) : null}
                        </div>
                      </Tab>
                    </>
                  ) : null}
                  {orderData?.delivery_mode == "home_office" &&
                  !showDeliveryType?.schedule ? null : (
                    <Tab
                      className="common-pointer bg-white-A700 border border-gray-300 border-solid flex flex-1 gap-3 flex-row items-center justify-start p-5 w-full"
                      isSelected={activeTab === 2}
                      onClick={() => handleTabClick(2)}
                    >
                      <Radio
                        className="flex items-center justify-start"
                        name="Deliverytype"
                        checked={activeTab === 2}
                        onChange={() => handleTabClick(2)}
                      />
                      <div className="flex flex-row gap-1 items-start justify-start w-auto">
                        <Img
                          className="h-6 w-6"
                          src="/images/img_calendar_24x24.svg"
                          alt="calendar"
                        />
                        <Text className="text-black-900 text-sm w-auto font-nunitomedium">
                          {t("scheduleTime")}
                        </Text>
                      </div>
                    </Tab>
                  )}
                  {orderData?.delivery_mode == "home_office" &&
                  !showDeliveryType?.schedule &&
                  !showDeliveryType?.fastest ? (
                    <Text className="text-base text-red-900 font-nunitoregular">
                      {t("experiencingHighTraffic")}
                    </Text>
                  ) : null}
                </>
              )}
            </div>
             {( activeTab === 1 ) ?
             <Text className="text-black-900 text-sm my-2 w-auto font-nunitomedium">
              {t("estimatedDelivery")} {fastestTimeSlots?.estimatedMinutes} - {fastestTimeSlots?.estimatedMinutes + 30} {t("minutes")}
             </Text> : null}
            <Panal
              isSelected={activeTab === 2}
              className="flex flex-col items-start justify-start w-full mt-7 hidden"
            >
              <div className="flex flex-col gap-3 items-start justify-start w-full">
                <Text className="text-base text-black-900 font-nunitomedium">
                  {t("selectDate")}
                </Text>
                <div className="max-w-[350px] w-full">
                  <DatepickerInput
                    format={"DD/MM/YYYY"}
                    required={true}
                    disablePast={true}
                    label={t("deliveryDate")}
                    value={timeslotData?.date}
                    min={timeslotData?.initialDate}
                    onChange={(e) => {
                      changeDate(e);
                      setTimeslotSelected({ ...timeslotSelected, id: 0 });
                    }}
                  />
                </div>
              </div>
              <div className="flex flex-col gap-3 items-start justify-start w-full">
                <Text className="text-base text-black-900 font-nunitomedium">
                  {slotData.length > 0
                    ? t("availableTimeSlots")
                    : t("noSloatFound")}
                </Text>
                <div className="w-full flex flex-wrap gap-3">
                  {slotData?.map((items, index) => {
                    return (
                      <TimeSlotRadio
                        label={CUSTOM.formatTimeRange(
                          items?.openTime,
                          items?.closeTime
                        )}
                        checked={{
                          slotId: timeslotSelected?.id,
                          id: items?.id,
                        }}
                        discount={items?.discount ? items?.discount : 0}
                        name="time"
                        className="w-auto"
                        id={`slot-${index}`}
                        onClick={(e) => {
                          setSlotTime(items);
                        }}
                      />
                    );
                  })}
                </div>
              </div>
              <div className="w-full max-w-[242px] mt-8 flex flex-row gap-4 mb-[18px]">
                <Button
                  className="flex-1 mx-auto"
                  size="lg"
                  variant="FillBlack"
                  hover={true}
                  hoverclass="bg-white-A700"
                  disabled={disableTimeButton}
                  onClick={(e) => {
                    continueTime();
                  }}
                >
                  {t("continue")}
                </Button>
              </div>
            </Panal>
            <Panal
              isSelected={activeTab === 1}
              className="flex flex-col items-start justify-start w-full hidden"
            >
              {orderData?.delivery_mode == "home_office" ? (
                <div className="w-full max-w-[242px] mt-8 flex flex-row gap-4 mb-[18px]">
                  <Button
                    className="flex-1 mx-auto"
                    size="lg"
                    variant="FillBlack"
                    hover={true}
                    hoverclass="bg-white-A700"
                    onClick={(e) => {
                      continueTime();
                    }}
                  >
                    {t("continue")}
                  </Button>
                </div>
              ) : null}
            </Panal>
          </>
        ) : null}
      </div>
    </>
  );
};

export default DeliveryDateTime;
